import { useParams } from "react-router-dom";
import { useScrollToElement } from "@/hooks/useScrollToElement";

export const useSyncSelectedContentElement = () => {
  const { contentElementId: selectedContentElementId } = useParams<{
    contentElementId: string;
  }>();

  useScrollToElement(
    selectedContentElementId ? `element-${selectedContentElementId}` : null
  );
};
